export default __webpack_public_path__ + "static/media/striding-feather-zampanio_is_a_game_you_COULD_play_it.45480fe7.jpg";